import { Injectable } from '@angular/core';
import { InteractionDateModel, InteractionTypeModel, InteractionWhoModel, MultiDeviceInteractionModel, MultiDeviceInteractionState } from '../models/consumer/consumer-interaction.model';

@Injectable()
export class MultiDeviceInteractionService {

    getNextState(currentState?: MultiDeviceInteractionState) {
        let nextState = MultiDeviceInteractionState.what;

        switch (currentState) {
            case MultiDeviceInteractionState.what:
                nextState = MultiDeviceInteractionState.when;
                break;
            case MultiDeviceInteractionState.when:
                nextState = this.whatModel.isGet ?
                    MultiDeviceInteractionState.who : this.whatModel.isSkipHow ?
                        MultiDeviceInteractionState.who : MultiDeviceInteractionState.how;
                break;
            case MultiDeviceInteractionState.how:
                nextState = MultiDeviceInteractionState.who;
                break;
            case MultiDeviceInteractionState.who:
                nextState = MultiDeviceInteractionState.summary;
                break;
        }

        return nextState;
    }

    get getModelMultiDeviceModel() {
        let model = JSON.parse(window.sessionStorage.getItem('multi-device-interaction')) as MultiDeviceInteractionModel;
        if (!model) return null;
        return model;
    }

    get whatModel() {
        let model = JSON.parse(window.sessionStorage.getItem('multi-device-interaction')) as MultiDeviceInteractionModel;
        if (!model) return null;
        return model.what;
    }

    set whatModel(value: InteractionTypeModel) {
        let model = JSON.parse(window.sessionStorage.getItem('multi-device-interaction')) as MultiDeviceInteractionModel;

        if (!model) {
            let fallBack = new MultiDeviceInteractionModel();
            fallBack.what = new InteractionTypeModel();
            fallBack.what = value;
            window.sessionStorage.setItem('multi-device-interaction', JSON.stringify(fallBack));
        } else {
            model.what = value;
            window.sessionStorage.setItem('multi-device-interaction', JSON.stringify(model));
        }
    }

    get whenModel() {
        let model = JSON.parse(window.sessionStorage.getItem('multi-device-interaction')) as MultiDeviceInteractionModel;
        if (!model) return null;
        return model.when;
    }

    set whenModel(value: InteractionDateModel) {
        let model = JSON.parse(window.sessionStorage.getItem('multi-device-interaction')) as MultiDeviceInteractionModel;

        if (!model) {
            let fallBack = new MultiDeviceInteractionModel();
            fallBack.what = new InteractionTypeModel();
            fallBack.when = value;
            window.sessionStorage.setItem('multi-device-interaction', JSON.stringify(fallBack));
        } else {
            model.when = value;
            window.sessionStorage.setItem('multi-device-interaction', JSON.stringify(model));
        }
    }

    get whoModel() {
        let model = JSON.parse(window.sessionStorage.getItem('multi-device-interaction')) as MultiDeviceInteractionModel;
        if (!model)  return null;
        return model.who;
    }

    set whoModel(value: InteractionWhoModel) {
        let model = JSON.parse(window.sessionStorage.getItem('multi-device-interaction')) as MultiDeviceInteractionModel;

        if (!model) {
            let fallBack = new MultiDeviceInteractionModel();
            fallBack.who = new InteractionWhoModel();
            fallBack.who = value;
            window.sessionStorage.setItem('multi-device-interaction', JSON.stringify(fallBack));
        } else {
            model.who = value;
            window.sessionStorage.setItem('multi-device-interaction', JSON.stringify(model));
        }
    }

    get howModel() {
        let model = JSON.parse(window.sessionStorage.getItem('multi-device-interaction')) as MultiDeviceInteractionModel;
        if (!model) return null;
        return model.how;
    }

    clear() {
        window.sessionStorage.removeItem('multi-device-interaction');
    }
}
